import { AuthContext } from "@app/lib/auth/AuthContext";
import { usePathParam } from "@app/lib/platform";
import { useChat } from "@app/lib/swr/chats";
import { useContext } from "react";

export function useActiveConversationId() {
  const owner = useContext(AuthContext)?.workspace ?? null;
  const cId = usePathParam("cId");
  const chatId = usePathParam("chatId");
  const { chat } = useChat({
    owner,
    chatId: chatId ?? "",
    disabled: cId !== null || !chatId,
  });

  if (cId !== null) {
    return cId === "new" ? null : cId;
  }
  if (chatId) {
    return chat?.latestConversationId ?? null;
  }
  return null;
}
